import React from "react";

const Gawowed = ({ width = 170 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 93.65 25.35"
    width={width}
  >
    <path d="M12.25,16.81v7.38h-2v-.83A6.89,6.89,0,0,1,7,24.19a7,7,0,0,1-7-7,7.29,7.29,0,0,1,.26-1.88l1.89,1.89a4.83,4.83,0,0,0,8.13,3.53v-2H7.85v-2Zm-9.8-1.27L.82,13.91a7,7,0,0,1,11.09-1.68l-1.42,1.63a4.83,4.83,0,0,0-8,1.68Z" />
    <path d="M14.79,21.74,16,22.91l-.57,1.31H13.74Zm8.5,2.48H21.64l-3.12-7.15L16.45,21.8l-1.18-1.19,3.25-7.7.9,2.15Z" />
    <path d="M33,15.43l1.19,1.19-2,7.57H30.65l-2.21-8.31h0l-2.21,8.29h0v0H24.72l-3-11.36h1.51l2.27,8.51,2.2-8.3H29.2l2.2,8.29Zm2.2-2.6-.67,2.53-1.2-1.19.36-1.34Z" />
    <path d="M43.62,21.85l1.25,1.26a5.68,5.68,0,0,1-7.95-7.95l1.25,1.25a4,4,0,0,0-.64,2.16,3.93,3.93,0,0,0,6.09,3.28Zm3.52-3.28a5.66,5.66,0,0,1-1.44,3.77L44.46,21.1a3.93,3.93,0,0,0-5.53-5.54l-1.24-1.23a5.67,5.67,0,0,1,9.45,4.24Z" />
    <path d="M58.8,15.43,60,16.62l-2,7.57H56.47l-2.21-8.31h0l-2.21,8.29h0v0H50.54l-3-11.36H49l2.27,8.51,2.2-8.3H55l2.2,8.29Zm2.2-2.6-.67,2.53-1.2-1.19.36-1.34Z" />
    <path d="M64.52,21.05l-1.6-1.6V12.9h0L63,13l-.12-.12h6.67l.58,1.6H64.52v3.14h2.14v1.6H64.52Zm5.07,1.61.58,1.6H62.92V21.05l1.6,1.6h5.07Z" />
    <path d="M80.33,18.57a5.68,5.68,0,0,1-5.68,5.68H72.1V18.61l1.6,1.6v2.18a4.26,4.26,0,0,0,1,.11,3.93,3.93,0,0,0,0-7.86c-.18,0-.78.09-1,.11h0v3.86L72.1,17V12.89h2.55A5.68,5.68,0,0,1,80.33,18.57Z" />
    <circle cx="69.55" cy="8.47" r="1.19" />
    <circle cx="74.59" cy="8.69" r="1.19" />
    <circle cx="72.13" cy="6.06" r="1.19" />
    <circle cx="77.22" cy="6.23" r="1.19" />
    <circle cx="79.63" cy="8.81" r="1.19" />
    <circle cx="74.76" cy="3.6" r="1.19" />
    <circle cx="79.8" cy="3.82" r="1.19" />
    <circle cx="82.21" cy="6.4" r="1.19" />
    <circle cx="77.34" cy="1.19" r="1.19" />
    <circle cx="82.38" cy="1.41" r="1.19" />
    <circle cx="84.79" cy="3.99" r="1.19" />
    <circle cx="84.62" cy="8.98" r="1.19" />
    <circle cx="87.2" cy="6.57" r="1.19" />
    <circle cx="84.5" cy="14.02" r="1.19" />
    <circle cx="87.08" cy="11.61" r="1.19" />
    <circle cx="89.66" cy="9.2" r="1.19" />
    <circle cx="84.28" cy="19.06" r="1.19" />
    <circle cx="86.91" cy="16.6" r="1.19" />
    <circle cx="89.49" cy="14.19" r="1.19" />
    <circle cx="92.07" cy="11.78" r="1.19" />
    <circle cx="87.47" cy="1.48" r="1.19" />
    <circle cx="89.88" cy="4.05" r="1.19" />
    <circle cx="92.34" cy="6.69" r="1.19" />
    <circle cx="84.22" cy="24.16" r="1.19" />
    <circle cx="86.79" cy="21.75" r="1.19" />
    <circle cx="89.43" cy="19.29" r="1.19" />
    <circle cx="92" cy="16.88" r="1.19" />
    <circle cx="92.47" cy="1.64" r="1.19" />
  </svg>
);

export default Gawowed;
